import { Checkbox, FormControlLabel } from '@mui/material'
import classNames from 'classnames'
import { useField } from 'formik'

import useStyles from 'src/components/shared/ui/form/fields/styles'
import { theme } from 'src/providers/ThemeProvider'
import { CheckboxIcon, CheckboxSelectedIcon } from '../../Icons'

type Props = {
  id: string
  label: string
  readOnly?: boolean
  required?: boolean
}

const styles: any = {
  formControlLabel: {
    '& .MuiFormControlLabel-label': {
      color: theme.colors.gray14,
      fontFamily: theme.corporate.primaryFont,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '18px',
      marginLeft: '4px'
    },

    '& .MuiSvgIcon-root': {
      fontSize: '22px'
    }
  }
}

function CheckBoxField({ id, label, readOnly, required }: Props): JSX.Element {
  const classes = useStyles()
  const [fieldInfo, meta] = useField(id)

  const checkboxClassNames = classNames(
    {
      required,
      error: meta.error
    },
    classes.wrapperCheckbox
  )

  return (
    <div className={checkboxClassNames}>
      <FormControlLabel
        control={
          <Checkbox
            {...fieldInfo}
            readOnly={readOnly}
            defaultChecked={fieldInfo.value}
            className={classes.checkbox}
            icon={<CheckboxIcon htmlColor={theme.colors.gray14} />}
            checkedIcon={<CheckboxSelectedIcon htmlColor={theme.corporate.primaryColor} />}
          />
        }
        labelPlacement="end"
        label={label}
        sx={styles.formControlLabel}
      />
    </div>
  )
}

export default CheckBoxField
